import {
  BarChart3,
  Boxes,
  FolderTree,
  LayoutGrid,
  LogOut,
  Menu,
  PackageOpen,
  PackageSearch,
  Shirt,
  ShoppingBag,
  Users,
  UserRoundCog,
  X,
} from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { appConfig } from '../../lib/env';
import { cn, getInitials } from '../../lib/utils';
import { useAuth } from '../../providers/AuthProvider';

const primaryNav = [
  { to: '/admin', label: 'Dashboard', icon: BarChart3, end: true },
  { to: '/admin/pedidos', label: 'Pedidos', icon: ShoppingBag },
  { to: '/admin/productos', label: 'Artículos', icon: Shirt },
  { to: '/admin/clientes', label: 'Clientes', icon: Users },
];

const secondaryNav = [
  { to: '/admin/categorias', label: 'Categorías', icon: FolderTree },
  { to: '/admin/lotes', label: 'Lotes / Excel', icon: Boxes },
  { to: '/admin/usuarios', label: 'Usuarios', icon: UserRoundCog, adminOnly: true },
  { to: '/', label: 'Ver catálogo', icon: LayoutGrid },
  { to: '/seguimiento', label: 'Probar seguimiento', icon: PackageSearch },
];

export function AdminShell() {
  const { profile, signOut } = useAuth();
  const [moreOpen, setMoreOpen] = useState(false);
  const location = useLocation();

  const visibleSecondary = secondaryNav.filter((item) => !item.adminOnly || profile?.role === 'admin');

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <Link to="/admin" className="admin-brand">
          <span>{appConfig.storeName}</span>
          <small>CONTROL</small>
        </Link>
        <nav className="admin-sidebar__nav" aria-label="Navegación de gestión">
          <p>Operativa</p>
          {primaryNav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
          <p>Configuración</p>
          {visibleSecondary.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to}>
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-user-card">
          <span className="avatar">{getInitials(profile?.full_name || profile?.email || 'U')}</span>
          <div>
            <strong>{profile?.full_name || 'Usuario'}</strong>
            <small>{profile?.role === 'admin' ? 'Administrador' : 'Personal'}</small>
          </div>
          <button type="button" className="icon-button" onClick={handleSignOut} aria-label="Cerrar sesión">
            <LogOut size={18} />
          </button>
        </div>
      </aside>

      <div className="admin-content">
        <header className="admin-topbar">
          <Link to="/admin" className="brand">
            {appConfig.storeName}
          </Link>
          <div className="admin-topbar__context">
            <PackageOpen size={18} />
            <span>Gestión interna</span>
          </div>
          <button
            type="button"
            className="icon-button"
            onClick={() => setMoreOpen(true)}
            aria-label="Abrir menú"
          >
            <Menu size={21} />
          </button>
        </header>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>

      <nav className="admin-bottom-nav" aria-label="Navegación móvil">
        {primaryNav.slice(0, 4).map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end}>
            <Icon size={20} />
            <span>{label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          className={cn(moreOpen && 'active')}
          onClick={() => setMoreOpen(true)}
        >
          <Menu size={20} />
          <span>Más</span>
        </button>
      </nav>

      <div className={cn('mobile-sheet-backdrop', moreOpen && 'is-open')} onMouseDown={() => setMoreOpen(false)}>
        <aside className="mobile-sheet" onMouseDown={(event) => event.stopPropagation()}>
          <header>
            <div>
              <p className="eyebrow">MENÚ</p>
              <h2>Gestión</h2>
            </div>
            <button type="button" className="icon-button" onClick={() => setMoreOpen(false)}>
              <X size={20} />
            </button>
          </header>
          <nav>
            {visibleSecondary.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={cn(location.pathname === to && 'active')}
                onClick={() => setMoreOpen(false)}
              >
                <Icon size={19} />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>
          <button type="button" className="mobile-sheet__logout" onClick={handleSignOut}>
            <LogOut size={19} /> Cerrar sesión
          </button>
        </aside>
      </div>
    </div>
  );
}
